<!-- 各保险公司保险收益（元） -->
<template>
	<div :id="id" class="o-echarts"></div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts';
import moment from 'moment';
let chart = null;
//var xAxisData = ['永安保险', '华安保险', '大众保险', '人民保险', '天安保险', '人寿保险', '阳光保险', '太平洋保险', '华泰保险', '东方保险'];
var data1 = [];
var data2 = [];
var data3 = [];
var data4 = [];
// for (var i = 0; i < 10; i++) {
// 	xAxisData.push('Class' + i);
// 	data1.push((Math.random() * 2).toFixed(2));
// 	data2.push(-Math.random().toFixed(2));
// 	data3.push((Math.random() * 5).toFixed(2));
// 	data4.push((Math.random() + 0.3).toFixed(2));
// }

function Max(value) {
    let maxStr = +`${parseInt(Math.abs(value.max))}` [0] + 1
    let minStr = +`${parseInt(Math.abs(value.min))}` [0] + 1
    for (let i = 0; i < `${Math.ceil(Math.abs(value.max))}`.length - 1; i++) {
        maxStr += '0'
    }
    for (let i = 0; i < `${Math.ceil(Math.abs(value.min))}`.length - 1; i++) {
        minStr += '0'
    }
    return Math.abs(value.max) > Math.abs(value.min) ?
        +maxStr :
        +minStr
}

function Min(value) {
    let maxStr = +`${parseInt(Math.abs(value.max))}` [0] + 1
    let minStr = +`${parseInt(Math.abs(value.min))}` [0] + 1
    for (
        let i = 0; i < `${Math.ceil(Math.abs(value.max))}`.length - 1; i++
    ) {
        maxStr += '0'
    }
    for (
        let i = 0; i < `${Math.ceil(Math.abs(value.min))}`.length - 1; i++
    ) {
        minStr += '0'
    }
    return value.min >= 0 ?
        0 :
        Math.abs(value.max) > Math.abs(value.min) ?
        - +maxStr :
        - +minStr
}

var emphasisStyle = {
	itemStyle: {
		barBorderWidth: 1,
		shadowBlur: 10,
		shadowOffsetX: 0,
		shadowOffsetY: 0,
		shadowColor: 'rgba(0,0,0,0.5)'
	}
};
export default {
	name: 'SettlementEarningsChart',
	props: {
		id: {
			type: String,
			required: false,
			default: 'SettlementEarningsChart'
		},
		subtext: {
			type: String,
			required: false,
			default: moment().format('YYYY年MM月DD日')
		}
	},
	data() {
		return {
			// id: 'SettlementEarningsChart',//地图渲染容器id
			option: {
				title: {
					text: '',
					subtext: '2020年04月26日',
					left: 'right',
					top: 10
				},
				dataset: {
					// dimensions: ['insurance', '保费收入', '收益情况', '理赔支出'],
					// source: [
					// 	{ headCompanyName: '永安保险', 保费收入: 1000,  收益情况: 1200,理赔支出: -1500, },
					// 	{ headCompanyName: '华安保险', 保费收入: 1000,  收益情况: 1200,理赔支出: -1500,  },
					// 	{ headCompanyName: '大众保险', 保费收入: 1000,  收益情况: 1200,理赔支出: -1500,  },
					// 	{ headCompanyName: '人民保险', 保费收入: 1000,  收益情况: 1200,理赔支出: -1500,  },
					// 	{ headCompanyName: '天安保险', 保费收入: 1000,  收益情况: 1200,理赔支出: -1500,   },
					// 	{ headCompanyName: '人寿保险', 保费收入: 1000,  收益情况: 1200,理赔支出: -1500,  },
					// 	{ headCompanyName: '阳光保险', 保费收入: 1000,  收益情况: 1200,理赔支出: -1500,  },
					// 	{ headCompanyName: '太平洋保险', 保费收入: 1000,  收益情况: 1200,理赔支出: -1500,  },
					// 	{ headCompanyName: '华泰保险', 保费收入: 1000,  收益情况: 1200,理赔支出: -1500,  },
					// 	{ headCompanyName: '东方保险', 保费收入: 1000,  收益情况: 1200,理赔支出: -1500,  },
					// ]
				},
				tooltip: {
					trigger: 'axis'
				},
				legend: {
					top: 0,
					// left: 10,
					itemGap: 20,
					itemWidth: 10,
					itemHeight: 10,
					textStyle: {
						color: '#333'
					},
					icon: 'rect'
					//data: ['保费收入', '理赔支出', '收益情况']
				},
				xAxis: {
					type: 'category',
					//data: xAxisData,
					axisTick: {
						show: false
					},
					axisLine: {
						lineStyle: {
							color: '#aaa',
							type: 'dotted',
							onZero: true
						}
					},
					axisLabel: {
						interval: 0, //x轴数据显示完整
						// rotate: 30,
						color: '#333'
					},
					splitArea: { show: false }
				},
				yAxis: [{
				            //inverse: true,//是否翻转
				            type: 'value',
				            axisTick: {
				            	show: false
				            },
				            splitLine: {
				            	lineStyle: {
				            		type: 'dotted'
				            	}
				            },
				            axisLine: {
				            	show: false
				            },
				            // 右侧y轴百分比对应折线图的最大最小值
				            max: value => Max(value),
				            min: value => Min(value)
				        },
				        {
				            //inverse: true,//是否翻转
				            type: 'value',
				            axisTick: {
				            	show: false
				            },
				            splitLine: {
				            	lineStyle: {
				            		type: 'dotted'
				            	}
				            },
				            axisLine: {
				            	show: false
				            },
				            // 右侧y轴百分比对应折线图的最大最小值
				            max: value => Max(value),
				            min: value => Min(value)
				        }
				    ],
				grid: {
					left: 100,
					right: 5
				},
				color: ['#1a8dee', '#ff9023', '#00d5b2'],
				series: [
					{
						name: '',
						type: 'bar',
						// stack: 'one',
						//emphasis: emphasisStyle,
						//data: [64050, 54650, 43920, 47423, 32745, 4385, 49858, 34744, 59068, 48754],
						barWidth: 14
					},
					{
						name: '',
						type: 'bar',
						// stack: 'two',
						//emphasis: emphasisStyle,
						//data: [66050, 85650, 40520, 95487, 37444, 34553, 54656, 35969, 43565, 57744],
						barWidth: 14
					},
					{
						name: '',
						type: 'bar',
						// stack: 'one',
						//emphasis: emphasisStyle,
						//data: [-94050, -24650, -43520, -23744, -36462, -47465, -32344, -47345, -96747, -37475],
						barWidth: 14
					}
				]
			}
		};
	},
	mounted() {
		// this.initMap()
	},
	watch: {},
	methods: {
		listenResize() {
			//窗口改变大小
			if (chart) {
				chart.resize();
			}
		},
		initMap(optionData) {
			//设置时间
			if (optionData.date) {
				this.option.title.subtext = optionData.date+'年' || '';
			}
			if (optionData.dataZoom) {
				this.option.dataZoom[0].show = optionData.dataZoom;
			}
			this.option.dataset = optionData.dataset || [];
			//console.log(this.option.dataset)
			chart = echarts.init(document.getElementById(this.id));
			chart.setOption(this.option);
			if (optionData.chartHeight) {
				chart.resize({ height: optionData.chartHeight });
			} else {
				chart.resize({ height: 300 });
			}
		}
	},
	components: {}
};
</script>

<style scoped lang="less">
.o-echarts {
	min-width: 30px;
	min-height: 30px;
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/homechart/SettlementEarningsChart.vue